import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router';
import dayjs from 'dayjs';
import { Container } from '../../../ui/gridSystem';
import { CTA, NoLiveEvent, Text } from '../../../ui/atoms';
import theme from '../../../ui/theme';
import { EventCard, Legend, LegendAndCard, Section } from './style';
import { withMediaQueries } from '../../hoc/withMediaQueries';
import routes from '../../../routes';
import { LIVE_EVENTS_GET } from '../../redux/actions/liveEvent';
import { timestampToDate } from '../../../utils/common';

const LiveEventList = ({
  mediaIsPhone,
  todayEvents,
  nextEvents,
  getLiveEvents,
}) => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    const today = dayjs();
    const tomorrow = today.add(1, 'day');
    const next_day = today.add(10, 'day');
    // today
    getLiveEvents(
      {
        typology: 'event',
        approval_status: 'APPROVED',
        start_date: today.format('DD-MM-YYYY'),
        end_date: today.format('DD-MM-YYYY'),
      },
      true // today events
    );
    // next events
    getLiveEvents({
      typology: 'event',
      approval_status: 'APPROVED',
      start_date: tomorrow.format('DD-MM-YYYY'),
      end_date: next_day.format('DD-MM-YYYY'),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      <Text type="h1" mb={8}>
        Gestione eventi dal vivo
      </Text>
      <Text type="b3" mb={mediaIsPhone ? 32 : 48}>
        Gestisci e monitora i tuoi eventi dal vivo.
      </Text>
      <Section>
        <Text type="h1.5" mb={mediaIsPhone ? 24 : 32}>
          Eventi di oggi
        </Text>
        {todayEvents.length > 0 ? (
          todayEvents.map((event, i) => (
            <LegendAndCard
              key={`event-${i}`}
              gridTemplateColumns="60px 1fr 150px 150px 100px"
              gridTemplateRows="20px 75px 37px 24px 32px"
            >
              {(i === 0 || mediaIsPhone) && (
                <Legend>
                  <Text type="statistics-heading">Codice</Text>
                  <Text type="statistics-heading">
                    Titolo percorso formativo
                  </Text>
                  <Text type="statistics-heading">Area tematica</Text>
                  <Text type="statistics-heading">Materia</Text>
                </Legend>
              )}
              <EventCard>
                <Text type="b5" color={theme().colors.primaryDarkGray700}>
                  {event?.code}
                </Text>
                <Text type="h3" className="ellipsis">
                  {event?.title}
                </Text>
                <Text type="b4" className="ellipsis">
                  {event?.category?.name}
                </Text>
                <Text type="b4">{event?.subject?.name}</Text>
                <CTA
                  type="tertiary"
                  btnText="Dettaglio"
                  icon={mediaIsPhone ? 'arrow-narrow-right' : 'chevron-right'}
                  onClick={() =>
                    navigate(`${routes.liveEvent.path}/${event?.id}`)
                  }
                />
              </EventCard>
            </LegendAndCard>
          ))
        ) : (
          <NoLiveEvent />
        )}
      </Section>
      <Section>
        <Text type="h1.5" mb={mediaIsPhone ? 24 : 32}>
          Prossimi eventi
        </Text>
        {nextEvents?.length > 0 ? (
          nextEvents.map((event, i) => (
            <LegendAndCard
              key={`event-${i}`}
              gridTemplateColumns="60px 1fr 150px 150px 100px 100px"
              gridTemplateRows="20px 75px 37px 24px 24px 32px"
            >
              {(i === 0 || mediaIsPhone) && (
                <Legend>
                  <Text type="statistics-heading">Codice</Text>
                  <Text type="statistics-heading">
                    Titolo percorso formativo
                  </Text>
                  <Text type="statistics-heading">Area tematica</Text>
                  <Text type="statistics-heading">Materia</Text>
                  <Text type="statistics-heading">Data</Text>
                </Legend>
              )}
              <EventCard>
                <Text type="b5" color={theme().colors.primaryDarkGray700}>
                  {event?.code}
                </Text>
                <Text type="h3" className="ellipsis">
                  {event?.title}
                </Text>
                <Text type="b4" className="ellipsis">
                  {event?.category?.name}
                </Text>
                <Text type="b4">{event?.subject?.name}</Text>
                <Text type="b4">{timestampToDate(event?.created)}</Text>
                <CTA
                  type="tertiary"
                  btnText="Dettaglio"
                  icon={mediaIsPhone ? 'arrow-narrow-right' : 'chevron-right'}
                  onClick={() =>
                    navigate(`${routes.liveEvent.path}/${event?.id}`)
                  }
                />
              </EventCard>
            </LegendAndCard>
          ))
        ) : (
          <NoLiveEvent />
        )}
      </Section>
    </Container>
  );
};

LiveEventList.propTypes = {
  //HOC: withMediaQueries
  mediaIsPhone: PropTypes.bool,
  // HOC: state
  todayEvents: PropTypes.array,
  nextEvents: PropTypes.array,
  // HOC: dispatch
  getLiveEvents: PropTypes.func,
};

export default compose(
  connect(
    (state) => {
      const {
        list: { todayEvents, nextEvents },
      } = state.liveEvent;
      return { todayEvents, nextEvents };
    },
    (dispatch) => ({
      getLiveEvents: (filters, isToday) =>
        dispatch({ type: LIVE_EVENTS_GET._REQUEST, filters, isToday }),
    })
  ),
  withMediaQueries
)(LiveEventList);
